module.exports = __webpack_public_path__ + "img/GreekTechHypastpist3_ua.8da02d4c.webp";